import has from 'lodash/fp/has';

import './PriceBreakdown.scss';
import PricingComponent from '../PricingComponent';
import { formatPrice, getTicketCountsBasedOnType } from '@micro-apps/shared';
import { useTranslation } from '../../../../hooks';

export default function PriceBreakdown({ currencyCode, modalDetails }) {
	const { t } = useTranslation();

	const { hotelProduct, totalPrice } = modalDetails;

	const content = {
		type: 'PriceBreakdown',
		pricingComponent: [],
	};
	if (has(['price', 'ticketBreakdown', 'ticketTypes'])(hotelProduct)) {
		content.pricingComponent[0] = hotelProduct.price.ticketBreakdown.ticketTypes.map(ticket => {
			const { numAdults = '', numChildren = '' } = hotelProduct;
			const ticketCounts = getTicketCountsBasedOnType(ticket, numAdults, numChildren);

			const titleFormats = {
				GRP:
					ticketCounts.adults && ticketCounts.children
						? t(
								`Base Rate - {0} ${ticketCounts.adults > 1 ? 'Adults' : 'Adult'}, {1} ${
									ticketCounts.children > 1 ? 'Children' : 'Child'
								}`,
								[ticketCounts.adults, ticketCounts.children]
							)
						: t(
								`Base Rate - {0} ${
									ticketCounts.adults
										? ticketCounts.adults > 1
											? 'Adults'
											: 'Adult'
										: ticketCounts.children > 1
											? 'Children'
											: 'Child'
								}`,
								[ticketCounts.adults || ticketCounts.children]
							),
				AAT: t(`{0} {1} x {2} ${ticketCounts.adults > 1 ? 'Adults' : 'Adult'}`, [
					ticket.currencyCode,
					ticket.perTicketAmount,
					ticketCounts.adults,
				]),
				ACD: t(`{0} {1} x {2} ${ticketCounts.children > 1 ? 'Children' : 'Child'}`, [
					ticket.currencyCode,
					ticket.perTicketAmount,
					ticketCounts.children,
				]),
				UNI: t(`{0} {1} x GROUP`, [ticket.currencyCode, ticket.amount]),
				ADT: t(`{0} {1} x {2} ${ticket.ticketCount > 1 ? 'Adults' : 'Adult'}`, [
					ticket.currencyCode,
					Number((ticket.amount / ticket.ticketCount).toFixed(2)),
					ticket.ticketCount,
				]),
				CHD: t(`{0} {1} x {2} ${ticket.ticketCount > 1 ? 'Children' : 'Child'}`, [
					ticket.currencyCode,
					Number((ticket.amount / ticket.ticketCount).toFixed(2)),
					ticket.ticketCount,
				]),
			};

			return {
				title: titleFormats[ticket.type],
				amount:
					ticket.amount === 0
						? t('Complimentary')
						: formatPrice({
								currencyCode: ticket.currencyCode,
								value: ticket.amount,
							}),
			};
		});
	}

	return (
		<div className="price-breakdown pb-400">
			{content.pricingComponent.map(price => {
				return (
					<div className="price-breakdown__section" key={price[0].title}>
						<PricingComponent prices={price} />
					</div>
				);
			})}
			{totalPrice && (
				<div className="price-breakdown__footer">
					<div className="ty-b1">{t('Est. Total')}</div>
					<div className="total-price">
						<div className="ty-h3">{totalPrice}</div>
						{has(['price', 'ticketBreakdown', 'ticketTypes'])(hotelProduct) && (
							<div className="shopping-cart-item__col__price-terms">
								{t('Taxes & fees may apply')}
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	);
}
